export const PRICING_PAGE_CONFIG = {
  cta: {
    startTrialCTA: {
      text: "Start a Free 30-Day Trial",
      redirect: "/auth",
    },
    loginCTA: {
      label: "Existing user?",
      text: "Login",
      redirect: "/login",
    },
    checkoutCTA: {
      text: "Checkout",
    },
    manageCTA: {
      text: "Manage subscription",
    },
    migrationCTA: {
      text: "Explore New Pricing",
    },
    contactCTA: {
      label: "Got questions?",
      text: "Contact us",
    },
  },
  billingToggle: {
    yearly: {
      label: "Billed Yearly",
      saveText: "Save up to 33%",
    },
    monthly: {
      label: "Billed Monthly",
    },
  },
  trialSection: {
    title: "How does the Aftershoot Trial work?",
    subTitle:
      "Try out the complete Aftershoot experience and decide which features you want to continue using.",
    steps: [
      {
        id: "_today",
        title: "Today",
        description:
          "You can use all Aftershoot features during your 30-day trial.",
        iconName: "LockIcon",
      },
      {
        id: "_before-trial-ends",
        title: "Before trial ends",
        description:
          "Select which features and add-ons you want to keep from the management page.",
        iconName: "CalendarIcon",
      },
      {
        id: "_when-trial-ends",
        title: "When trial ends",
        description:
          "Your Subscription Plan will only include the features and add-ons you leave at the end of the trial.",
        iconName: "StarIcon",
      },
    ],
  },
};
